import { render, staticRenderFns } from "./OnboardingBanner.vue?vue&type=template&id=39c3b37e&scoped=true"
import script from "./OnboardingBanner.vue?vue&type=script&lang=ts"
export * from "./OnboardingBanner.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingBanner.vue?vue&type=style&index=0&id=39c3b37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c3b37e",
  null
  
)

export default component.exports